<template>
	<div v-if="data">
		<template v-if="$platform.setting">
			<template v-if="$platform.setting.display_profit">
				<h3>Margen de beneficio</h3>
				<p :class="nameClass">
					<template v-if="data.profit_value">
						{{ data.profit_value }}
						<template v-if="currency">
							{{ currency.symbol }}
						</template>
					</template>
					<template v-if="data.profit_percent">
						| {{ data.profit_percent }}%
					</template>
				</p>
				<p :class="nameClass">
					{{ data.profit_value }}
					<template v-if="currency">
						{{ currency.symbol }}
					</template>
					<template v-if="data.measurement_unit_id != 1 || data.measurement_unit_id != 1">
						x {{ data.total_measurement_unit }}
						<template v-if="data.measurement_unit">
							{{ data.measurement_unit.name }}
						</template>
					</template>
					x {{ data.quantity }} Cant.
					= {{ data.profit_val_measurement_unit }}
					<template v-if="currency">
						{{ currency.symbol }}
					</template>
				</p>
			</template>
		</template>
	</div>
</template>

<script>
	import Ladda from 'ladda'

	export default {
		props: ['user', 'isAuth', 'data', 'currency'],
		data () {
			return {
				nameClass: null,
			}
		},
		mounted() {
			this.loadClass()
		},
		methods: {
			calculateProfit() {
				this.calculateValue()
				this.calculatePercent()
				this.calculateValueMeasurementUnit()
				this.loadClass()
			},
			calculateValue() {
				var purchase_price = 0
				if(this.data.purchase_price) {
					purchase_price = parseFloat(this.data.purchase_price).toFixed(2)
				}

				var price = 0
				if(this.data.price) {
					price = parseFloat(this.data.price).toFixed(2)
				}

				var profit_value = parseFloat(price - purchase_price).toFixed(2)
				this.data.profit_value = profit_value
			},
			calculatePercent() {
				var purchase_price = 0
				if(this.data.purchase_price) {
					purchase_price = parseFloat(this.data.purchase_price).toFixed(2)
				}

				var price = 0
				if(this.data.price) {
					price = parseFloat(this.data.price).toFixed(2)
				}

				var profit_value = 0
				if(this.data.profit_value) {
					profit_value = parseFloat(this.data.profit_value).toFixed(2)
				}

				if(purchase_price > 0) {
					var profit_percent = profit_value * 100
					if(profit_percent == 0) {
						profit_percent = 0
					} else {
						profit_percent = profit_percent / purchase_price
					}
				} else {
					if(price > 0) {
						var profit_percent = 100
					} else {
						var profit_percent = 0
					}
				}

				this.data.profit_percent = parseFloat(profit_percent).toFixed(2)
			},
			calculateValueMeasurementUnit() {
				var profit_value = 0
				if(this.data.profit_value) {
					profit_value = this.data.profit_value
				}

				var total_measurement_unit = 1
				if(this.data.total_measurement_unit) {
					total_measurement_unit = this.data.total_measurement_unit
				}

				var quantity = 1
				if(this.data.quantity) {
					quantity = this.data.quantity
				}

				var profit_val_measurement_unit = profit_value * total_measurement_unit * quantity
				this.data.profit_val_measurement_unit = parseFloat(profit_val_measurement_unit).toFixed(2)
			},
			loadClass() {
				if(this.data.profit_value == 0) {
					this.nameClass = 'text-muted'
				} else {
					if(this.data.profit_value < 0) {
						this.nameClass = 'text-danger'
					} else {
						this.nameClass = 'text-success'
					}
				}
			}
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/management/productStorages/views/Profit.vue